var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhotoScreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 266,
    height: 284,
    viewBox: "0 0 266 284",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 48.2422V1H48.2422",
    stroke: "#1C1C1C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 235.82V283.062H48.2422",
    stroke: "#1C1C1C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M265 48.2422V1H217.758",
    stroke: "#1C1C1C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M265 235.82V283.062H217.758",
    stroke: "#1C1C1C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhotoScreen);
export default __webpack_public_path__ + "static/media/PhotoScreen.77a78d16d7ca7270650b90905852d85b.svg";
export { ForwardRef as ReactComponent };